import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const BASE_URL  = process.env.REACT_APP_COMMUNITY_URL;
const DEFAULT_PARAMS  = { order_by: 'id', order: 'desc' };

// Assets
function assetsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/assets`, params);
}
function assetPath(this: any, id: number) {
  return `/${this.basePath}/assets/${id}`;
}

// Images
function imagesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/images`, params);
}
function imagePath(this: any, id: number) {
  return `/${this.basePath}/images/${id}`;
}

// Posts
function postPath(this: any, id: number) {
  return `/${this.basePath}/posts/${id}`;
}
function contentPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/content`, params);
}
function communityPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/community`, params);
}

function usersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/users`, params);
}
function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

function bundlesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/bundles`, params);
}
function bundlePath(this: any, id: number) {
  return `/${this.basePath}/bundles/${id}`;
}

function bundlePathBy(app_id: number, id: number) {
  return `/community/${app_id}/bundles/${id}`;
}

function commentPath(this: any, comment?: any) {
  const params = { tab: 'comment', go_to_comment: comment.id };
  let targetUrl;

  switch (comment.parent_target_type) {
    case 'Post':
      targetUrl = postPath.call(this, comment.parent_target_id);
      break;
    case 'User':
      targetUrl = userPath.call(this, comment.parent_target_id);
      break;
    default:
      targetUrl = '/404';
  }

  return targetUrl ? urlWithParams(targetUrl, params) : null;
}

function reportsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/reports`, params);
}

function settingsPath(this: any) {
  return urlWithParams(`/${this.basePath}/settings`);
}

function appPath(this: any, id: number) {
  return urlWithParams(`/community/${id}/settings`);
}

function appsPath(this: any) {
  return urlWithParams('/apps');
}

const communityUrls = {
  baseURL:    BASE_URL,
  get basePath(){
    const app_id = window.location.pathname.split('/')[2];
    return `community/${app_id}`;
  },
  remoteUrl:      remoteUrl,

  postPath:       postPath,

  assetsPath:     assetsPath,
  assetPath:      assetPath,

  imagesPath:     imagesPath,
  imagePath:      imagePath,

  contentPath:    contentPath,
  communityPath:  communityPath,

  usersPath:      usersPath,
  userPath:       userPath,

  bundlesPath:    bundlesPath,
  bundlePath:     bundlePath,
  bundlePathBy:   bundlePathBy,

  commentPath:    commentPath,
  reportsPath:    reportsPath,

  settingsPath:   settingsPath,

  appPath:        appPath,
  appsPath:       appsPath,

  app (id: number) {
    return {
      ...communityUrls,
      basePath: `community/${id}`,
    }
  }
}

export default communityUrls;
